
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'

@Component({})
export default class extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'SortableCaret'

  @Prop({
    type: String,
    default: 'DEFAULT'
  })
  sort: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled: boolean
}
